var React = require('react');
var { useRef, useState, useEffect } = React;
function useNodeMeasurement(zoomRef, nodesLength, showNodeDetails, hoveredPreviewNodeId) {
  var [sizes, setSizes] = useState({});
  var nodeRefs = useRef({});
  var resizeObserverRef = useRef(null);

  function measureNodes() {
    var nextSizes = {};
    Object.keys(nodeRefs.current).forEach(function(id) {
      var element = nodeRefs.current[id];
      if (!element) return;
      var entry = {
        width: element.offsetWidth,
        height: element.offsetHeight
      };
      var rows = element.querySelectorAll('.wf-node-classifier-row:not(.wf-node-classifier-row-add)');
      if (rows.length > 0) {
        var nodeTop = element.getBoundingClientRect().top;
        var z = zoomRef.current || 1;
        entry.classifierRowOffsets = Array.prototype.map.call(rows, function(row) {
          var rowRect = row.getBoundingClientRect();
          return ((rowRect.top + rowRect.height / 2) - nodeTop) / z;
        });
      }
      nextSizes[id] = entry;
    });
    setSizes(nextSizes);
  }

  function getResizeObserver() {
    if (!resizeObserverRef.current) {
      resizeObserverRef.current = new ResizeObserver(function() {
        measureNodes();
      });
    }
    return resizeObserverRef.current;
  }

  function setNodeRef(id) {
    return function(element) {
      var prev = nodeRefs.current[id];
      if (prev && prev !== element) {
        getResizeObserver().unobserve(prev);
      }
      if (element) {
        nodeRefs.current[id] = element;
        getResizeObserver().observe(element);
      } else {
        delete nodeRefs.current[id];
      }
    };
  }

  // Initial measurement + window resize
  useEffect(function() {
    measureNodes();
    window.addEventListener('resize', measureNodes);
    return function() {
      window.removeEventListener('resize', measureNodes);
      if (resizeObserverRef.current) resizeObserverRef.current.disconnect();
    };
  }, []);

  // Re-measure when node count or detail visibility changes
  useEffect(function() {
    if (typeof requestAnimationFrame !== 'function') {
      measureNodes();
      return;
    }
    var frameId = requestAnimationFrame(function() {
      measureNodes();
    });
    return function() {
      cancelAnimationFrame(frameId);
    };
  }, [nodesLength, showNodeDetails, hoveredPreviewNodeId]);

  return {
    sizes: sizes,
    nodeRefs: nodeRefs,
    setNodeRef: setNodeRef,
    measureNodes: measureNodes
  };
}

module.exports = useNodeMeasurement;
